import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";

export const HighlighterWrapper = styled(Box)`
  display: flex;
`;
